export default function AlfaLeiloesSwipersHome() {
    const el = document.querySelector('.swiper-home')
    if (!el) return
    if(!el.querySelectorAll('.swiper-slide').length) return 
    const swiperHome = new Swiper(el, {
        slidesPerView: "auto",
        spaceBetween: 40,
        speed: 1000,
        loop: true,
        autoplay: {
            delay: 6000,
            disableOnInteraction: false,
        },

        navigation: {
            nextEl: ".swiper-home .custom-arrow-next",
            prevEl: ".swiper-home .custom-arrow-prev",
            // nextEl: ".swiper-button-next",
            // prevEl: ".swiper-button-prev",
        },
    })
}